// extracted by mini-css-extract-plugin
export default {"header":"Section_header__mpTaY","toggleText":"Section_toggleText__pivNj","wrapper":"Section_wrapper__KwRRs","cardsWrapper":"Section_cardsWrapper__aDRAB"};